export default __webpack_public_path__ + "static/media/software-manufactura.73bfe892.webp";